import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useCreateMeeting, useMeetingFormOptions, useUpdateMeeting } from ".";

const eventSchema = yup.object({
  type: yup.object().nullable().required("Type is required"),
  name: yup.string().trim().required("Title is required"),
  startDate: yup.date().nullable().required("Start date is required"),
  endDate: yup
    .date()
    .nullable()
    .required("End date is required")
    .test(
      "end-date-after-start-date",
      "End date must be after start date",
      (value, ctx) => {
        return value.getTime() > ctx.parent.startDate?.getTime();
      }
    ),
  attendees: yup
    .array()
    .of(yup.object())
    .min(1, "Select at least one attendee"),
});

function useMeetingForm(meeting, onSubmit) {
  const { clientId } = useParams();

  const { createMeeting, isCreating } = useCreateMeeting(onSubmit);
  const { updateMeeting, isUpdating } = useUpdateMeeting(onSubmit);
  const { options, isLoadingOptions } = useMeetingFormOptions();

  const form = useForm({
    resolver: yupResolver(eventSchema),
    mode: "onSubmit",
    defaultValues: meeting,
  });

  return {
    isEdit: Boolean(meeting.id),
    form: form,
    options: options,
    loaders: {
      isSubmitting: isCreating || isUpdating,
      isLoadingOptions: isLoadingOptions,
    },
    submit: async (formData) => {
      const action = meeting.id ? updateMeeting : createMeeting;
      await action(formData, meeting.id || clientId);
    },
  };
}

export default useMeetingForm;
